import styled from "styled-components";
import { pxToRem, withAlpha } from "../../styles/utils";

export const DeletedRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${pxToRem(20)} ${pxToRem(24)};

  box-shadow: inset 0px ${pxToRem(3)} ${pxToRem(4)} 0px ${({ theme }) => withAlpha(theme.colors.black, 0.25)};
  background: ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.white};

  font-size: ${pxToRem(16)};
  font-weight: 500;
`;

export const DeletedRowMessage = styled.span`
  flex-grow: 1; /* Растягивается, занимая доступное пространство */
  font-size: ${pxToRem(18)};
  font-weight: 600;
  padding-left: ${pxToRem(32)};
`;

export const RestoreButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${pxToRem(14)};
  font-weight: 400;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
